import React from "react";
import { DEALER, buildDealerUrl } from "@/data/dealership";
import { useT } from "@/i18n/lang";
import { Phone, MapPin } from "lucide-react";
import FinancingCTA from "@/components/FinancingCTA";

export default function Footer() {
  const { t } = useT();
  return (
    <footer data-testid="footer" className="bg-[#0A0A0A] text-white px-6 md:px-12 lg:px-16 py-16">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-12 gap-8 mb-12">
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-[#EB0A1E] flex items-center justify-center font-display font-bold">JP</div>
              <div>
                <div className="font-display font-bold">{DEALER.consultant}</div>
                <div className="text-xs uppercase tracking-[0.15em] text-white/60">
                  {DEALER.role} · {DEALER.dealershipName}
                </div>
              </div>
            </div>
            <p className="text-white/60 text-sm max-w-md leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="text-xs uppercase tracking-[0.18em] text-white/40 mb-4">{t("footer.contact")}</div>
            <a href={`tel:${DEALER.phoneRaw}`} data-testid="footer-phone" className="flex items-center gap-2 text-sm hover:text-[#EB0A1E] transition-colors mb-3">
              <Phone className="w-4 h-4" /> {DEALER.phone}
            </a>
            <a href={DEALER.mapsUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-map" className="flex items-start gap-2 text-sm hover:text-[#EB0A1E] transition-colors">
              <MapPin className="w-4 h-4 mt-0.5" />
              <span>{DEALER.address}</span>
            </a>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="text-xs uppercase tracking-[0.18em] text-white/40 mb-4">{t("footer.quickLinks")}</div>
            <ul className="space-y-2 text-sm">
              <li><a href="#inventory" className="hover:text-[#EB0A1E] transition-colors">{t("nav.inventory")}</a></li>
              <li><a href="#appointment" className="hover:text-[#EB0A1E] transition-colors">{t("footer.bookAppt")}</a></li>
              <li><a href="#about" className="hover:text-[#EB0A1E] transition-colors">{t("nav.about")}</a></li>
              <li>
                <FinancingCTA page="footer" testid="footer-finance">
                  <button type="button" className="hover:text-[#EB0A1E] transition-colors text-left">
                    {t("footer.finance")} ↗
                  </button>
                </FinancingCTA>
              </li>
              <li>
                <a href={buildDealerUrl("/")} target="_blank" rel="noopener" className="hover:text-[#EB0A1E] transition-colors">
                  autonationtoyotasouthaustin.com ↗
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-white/40">
          <div>{t("footer.copyright").replace("{year}", new Date().getFullYear())}</div>
          <div>{t("footer.note")}</div>
        </div>
      </div>
    </footer>
  );
}
